<template>
  <SettlementReadinessCard
    title="Settlement Readiness"
    :status="status"
    :status-color="statusColor"
    :has-docusign="settlement.hasDocusign"
    :loading-docusign="loadingDocusign"
    :documents-ready="settlementReadinessDocumentsReady"
    :documents-signed="settlementReadinessDone"
    :is-mobile="$q.screen.xs"
    v-bind="$attrs"
    @sign:documents="signDocuments"
  />
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import PayrollDialog from '../../components/molecule/payroll-dialog';
import sendSettlementEvent from '../../utils/send-settlement-event';
import { openUrl } from 'ecx.saigon.ui.common';
import actions from '../../utils/actions';

export default {
  name: 'SettlementReadinessStep',
  data() {
    return {
      loadingDocusign: false
    };
  },
  computed: {
    ...mapState({
      settlement: (state) => state.settlement.settlement
    }),
    ...mapGetters('settlement', [
      'settlementReadinessDocumentsReady',
      'settlementReadinessDone'
    ]),
    ...mapGetters('user', ['theme']),
    status() {
      if (this.settlementReadinessDone) {
        return 'Completed';
      }
      return this.settlementReadinessDocumentsReady ? 'Ready' : 'Pending';
    },
    statusColor() {
      return this.settlementReadinessDone ||
        this.settlementReadinessDocumentsReady
        ? 'positive'
        : 'warning';
    }
  },
  methods: {
    async signDocuments() {
      try {
        this.loadingDocusign = true;
        if (!actions.onCallDocusign) {
          throw 'No action to call';
        }
        const url = await actions.onCallDocusign();
        if (!url) {
          throw 'Could not load docusign URL';
        }
        openUrl(url);
        this.loadingDocusign = false;
      } catch (err) {
        // eslint-disable-next-line
        console.error(err);
        this.loadingDocusign = false;
        this.$euiNotifications.emit({
          notification: this.$Constants.GLOBAL_ERROR,
          action: () => this.signDocuments()
        });
      }
    }
  },
  mounted() {
    sendSettlementEvent({
      label: `documents-${this.status.toLowerCase()}`
    });

    if (
      this.settlementReadinessDocumentsReady &&
      !this.settlementReadinessDone
    ) {
      const support = this.theme().support || {};
      this.$q.dialog({
        component: PayrollDialog,
        contactNumber: support.phone
      });
    }
  },
  components: {
    SettlementReadinessCard: () =>
      import('../../components/molecule/settlement-readiness-card')
  }
};
</script>
